import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, TreeNode } from 'primeng/api';
import { CidadeService } from '../../cidade/cidade.service';
import { Cidade } from '../../cidade/models/cidade';
import { FornecedorService } from '../../fornecedor/fornecedor.service';
import { EventoFornecedor } from '../../fornecedor/models/fornecedor';
import { Pessoa } from '../../pessoa/models/pessoa';
import { PessoaService } from '../../pessoa/pessoa.service';
import { ProdutoEventoFornecedor } from '../../produto/models/produto';
import { ProdutoService } from '../../produto/produto.service';
import { Usuario } from '../../usuario/models/usuario';
import { UsuarioService } from '../../usuario/usuario.service';
import { DashboardService } from '../dashboard.service';
import { filtroDashboard, kpi } from '../models/dashboard';

interface City {
  name: string,
  code: string
}

interface Country {
  name: string,
  code: string
}

@Component({
  selector: 'app-dashboard-evento-vendas',
  templateUrl: './dashboard-evento-vendas.component.html',
  styleUrls: ['./dashboard-evento-vendas.component.scss'],
  providers: [ConfirmationService, MessageService]
})



export class DashboardEventoVendasComponent implements OnInit {

  public idEvento: string = "1";
  public isVlBruto: boolean = true;
  public isVlLucro: boolean = false;
  public isVlEconomia: boolean = false;
  public idVisao: number = 1;
  public visao: string = "Valor Bruto";

  public kpi: kpi = {} as kpi;
  public Line: any;

  public pessoas: filtroDashboard[] = [];
  public selectedPessoas: filtroDashboard[] = [];
  public pessoaData: any;

  public cidades: filtroDashboard[] = [];
  public selectedCidades: filtroDashboard[] = [];
  public cidadeData: any;

  public vendedores: filtroDashboard[] = [];
  public selectedVendedores: filtroDashboard[] = [];
  public vendedorData: any;

  public fornecedores: filtroDashboard[] = [];
  public selectedFornecedores: filtroDashboard[] = [];
  public fornecedorData: any;

  public produtos: filtroDashboard[] = [];
  public selectedProdutos: filtroDashboard[] = [];
  public produtoData: any;

  public selectedFiltro: filtroDashboard[] = [];
  public filtro: string = "-";
  public listaFiltro: filtroDashboard[] = [];

  public doughnutOptions: any;
  public basicOptions: any;







  constructor(private dashboardService: DashboardService,
    public produtoService: ProdutoService,
    public fornecedorService: FornecedorService,
    public pessoaService: PessoaService,
    public usuarioService: UsuarioService,
    public cidadeService: CidadeService,
    private router: Router,
    private _Activatedroute: ActivatedRoute,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {

    this._Activatedroute.paramMap.subscribe(params => {
      if (params.has('idEvento')) {
        this.idEvento = params.get('idEvento');

        this.chartOptions();
        this.doughnutOpt();


        //filtros
        this.getProdutos(this.idEvento);
        this.getFornecedores(this.idEvento);
        this.getCidades(this.idEvento);
        this.getPessoas(this.idEvento);
        this.getVendedores(this.idEvento);


        //graficos
        this.carregaGraficos();
        this.getKpi(this.idEvento);
        this.getLine(this.idEvento);



      }
    });


  }

  buscar() {
    var lst = "";

    console.log(this.listaFiltro);
    
    

this.listaFiltro = this.selectedCidades
                    .concat(this.selectedFornecedores
                      .concat(this.selectedPessoas
                        .concat(this.selectedProdutos
                          .concat(this.selectedVendedores)
                        )
                      )
                    );

    
    // this.selectedPessoas.forEach(function (value) {
    //   if (value != undefined) {
    //     //var b = lst.concat("P" + value.id.toString() + ";");
    //     //lst = b;
        
    //     this.filtro = "P" + value.id.toString();
    //     console.log(this.filtro);
    //  //   this.listaFiltro.push(this.filtro);
    //     console.log(this.listaFiltro);

    //   }
    // });
    // console.log(this.listaFiltro);
    // console.log(this.selectedFornecedores);

    // this.selectedFornecedores.forEach(function (value) {
    //   if (value != undefined) {
    //     //var b = lst.concat("F" + value.id.toString() + ";");
    //     //lst = b;
    //     this.listaFiltro.push("F" + value.id.toString());
    //   }
    // });

    // this.selectedProdutos.forEach(function (value) {
    //   if (value != undefined) {
    //     //var b = lst.concat("R" + value.id.toString() + ";");
    //     //lst = b;
    //     this.listaFiltro.push("R" + value.id.toString());
    //   }
    // });

    // this.selectedVendedores.forEach(function (value) {
    //   if (value != undefined) {
    //     //var b = lst.concat("V" + value.id.toString() + ";");
    //     //lst = b;
    //     this.listaFiltro.push("V" + value.id.toString());
    //   }
    // });

    // this.selectedCidades.forEach(function (value) {
    //   if (value != undefined) {
    //     //var b = lst.concat("C" + value.id.toString() + ";");
    //     //lst = b;
    //     this.listaFiltro.push("C" + value.id.toString());
    //   }
    // });

    //this.filtro = lst;

    console.log(this.listaFiltro);

    this.carregaGraficos();
  
  }

  openDetalhe() {
    this.router.navigate(['/dashboard-evento-vendas-detalhe', this.idEvento]);
  }

  getProdutos(idEvento: string) {

    this.produtoService.getProdutosDashboard(idEvento).subscribe(
      (res) => {
        if (res) {
          this.produtos = res;
          this.selectedProdutos = this.produtos;
        }
      },
      err => {
        console.log("DashboardEventoVendas - Produtos");
        console.log(err);
      }
    );
  }

  getFornecedores(idEvento: string) {
    this.fornecedorService.getFornecedoresDashboard(idEvento).subscribe(
      (res) => {
        if (res) {
          this.fornecedores = res;
          this.selectedFornecedores = this.fornecedores
        }
      },
      err => {
        console.log("DashboardEventoVendas - Fornecedores");
        console.log(err);
      }
    );
  }

  getCidades(idEvento: string) {
    this.cidadeService.getCidadesDashboard(idEvento).subscribe(
      (res) => {
        if (res) {
          this.cidades = res;
          this.selectedCidades = this.cidades;
        }
      },
      err => {
        console.log("DashboardEventoVendas - Cidades");
        console.log(err);
      }
    );
  }

  getPessoas(idEvento: string) {
    this.pessoaService.getPessoasDashboard(idEvento).subscribe(
      (res) => {
        if (res) {
          this.pessoas = res;
          this.selectedPessoas = this.pessoas;
        }
      },
      err => {
        console.log("DashboardEventoVendas - Pessoas");
        console.log(err);
      }
    );
  }

  getVendedores(idEvento: string) {
    this.usuarioService.getVendedoresDashboard(idEvento).subscribe(
      (res) => {
        if (res) {
          this.vendedores = res;
          this.selectedVendedores = this.vendedores;
        }
      },
      err => {
        console.log("DashboardEventoVendas - Vendedores");
        console.log(err);
      }
    );
  }

  carregaGraficos() {
    this.getGraficoFornecedor(this.idEvento, this.idVisao, this.listaFiltro);
    this.getGraficoVendedor(this.idEvento, this.idVisao, this.listaFiltro);
    this.getGraficoCidade(this.idEvento, this.idVisao, this.listaFiltro);
    this.getGraficoProduto(this.idEvento, this.idVisao, this.listaFiltro);
    this.getGraficoCliente(this.idEvento, this.idVisao, this.listaFiltro);

  }

  getKpi(idEvento: string) {
    this.dashboardService.getKpi(idEvento).subscribe(
      (res) => {
        if (res) {
          this.kpi = res;
        }
      },
      err => {
        console.log("DashboardEventoVendas - FornecedorData");
        console.log(err);
      }
    );
  }

  getLine(idEvento: string) {
    this.dashboardService.getLine(idEvento).subscribe(
      (res) => {
        if (res) {
          this.Line = res;
        }
      },
      err => {
        console.log("DashboardEventoVendas - LineData");
        console.log(err);
      }
    );
  }

  getGraficoFornecedor(idEvento: string, idVisao: number, filtro: filtroDashboard[]) {
    this.dashboardService.getGraficoFornecedor(idEvento, idVisao, filtro).subscribe(
      (res) => {
        if (res) {
          this.fornecedorData = res;
        }
      },
      err => {
        console.log("DashboardEventoVendas - FornecedorData");
        console.log(err);
      }
    );
  }

  getGraficoVendedor(idEvento: string, idVisao: number, filtro: filtroDashboard[]) {
    this.dashboardService.getGraficoVendedor(idEvento, idVisao, filtro).subscribe(
      (res) => {
        if (res) {
          this.vendedorData = res;
        }
      },
      err => {
        console.log("DashboardEventoVendas - VendedorData");
        console.log(err);
      }
    );
  }

  getGraficoCidade(idEvento: string, idVisao: number, filtro: filtroDashboard[]) {
    this.dashboardService.getGraficoCidade(idEvento, idVisao, filtro).subscribe(
      (res) => {
        if (res) {
          this.cidadeData = res;
        }
      },
      err => {
        console.log("DashboardEventoVendas - CidadeData");
        console.log(err);
      }
    );
  }

  getGraficoProduto(idEvento: string, idVisao: number, filtro: filtroDashboard[]) {
    this.dashboardService.getGraficoProduto(idEvento, idVisao, filtro).subscribe(
      (res) => {
        if (res) {
          this.produtoData = res;
        }
      },
      err => {
        console.log("DashboardEventoVendas - ProdutoData");
        console.log(err);
      }
    );
  }


  getGraficoCliente(idEvento: string, idVisao: number, filtro: filtroDashboard[]) {
    this.dashboardService.getGraficoCliente(idEvento, idVisao, filtro).subscribe(
      (res) => {
        if (res) {
          this.pessoaData = res;
        }
      },
      err => {
        console.log("DashboardEventoVendas - ClienteData");
        console.log(err);
      }
    );
  }




  //=====================================================================
  //==================EVENTOS============================================
  //=====================================================================

  onChangeVisaoBruto(e) {
    if (e.checked) {
      this.isVlBruto = true;
      this.isVlLucro = false;
      this.isVlEconomia = false;
      this.visao = "Valor Bruto";
      this.idVisao = 1;
      this.carregaGraficos();
    }

  }

  onChangeVisaoLucro(e) {
    if (e.checked) {
      this.isVlBruto = false;
      this.isVlLucro = true;
      this.isVlEconomia = false;
      this.visao = "Valor Lucro";
      this.idVisao = 2;
      this.carregaGraficos();
    }
  }

  onChangeVisaoEconomia(e) {
    if (e.checked) {
      this.isVlBruto = false;
      this.isVlLucro = false;
      this.isVlEconomia = true;
      this.visao = "Valor Economia";
      this.idVisao = 3;
      this.carregaGraficos();
    }
  }




  chartOptions() {
    this.basicOptions = {
      legend: {
        labels: {
          fontColor: '#252529'
        }
      },
      scales: {
        xAxes: [{
          ticks: {
            fontColor: '#252529'
          },
          gridLines: {
            color: 'rgba(255,255,255,0.2)'
          }
        }],
        yAxes: [{
          ticks: {
            fontColor: '#252529'
          },
          gridLines: {
            color: 'rgba(255,255,255,0.2)'
          }
        }]
      }
    };
  }



  doughnutOpt() {
    this.doughnutOptions = {
      legend: {
        labels: {
          fontColor: '#101517',
          fontSize: 8

        },
        position: 'left'
      },
    };
  }


}
